import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button } from '@shopify/polaris'

import { SHOPIFY_GRAY } from 'components/styles'
import Text from 'components/common/Text'
import pic from 'assets/dashboard-empty-state.png'

const Wrapper = styled.div`
  font-size: 4rem;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: ${SHOPIFY_GRAY};
  cursor: pointer;
`
const Header = styled.div`
  margin-left: 1em;
  margin-top: 5em;
`
const Desc = styled.div`
  margin-left: 1em;
  margin-top: 1em;
`
const ButtonContainer = styled.div`
  margin-left: 1em;
  margin-top: 2.6em;
  & > * {
    font-size: 0.7em;
  }
`
const Image = styled.div`
  background-image: url('${pic}');
  background-repeat: no-repeat;
  background-size: contain;
  width: 12em;
  height: 12em;
  margin-left: 2em;
  margin-top: 0.5em;
  z-index: 1;
`

class CreateNewScene extends Component {
  render () {
    const { onClick } = this.props
    return (
      <Wrapper onClick={onClick} >
        <Header>
          <Text color='#212b36' styleRaw='font-weight: 600; text-align: left;'>Your products deserve to be beautifully showcased</Text>
        </Header>
        <Desc>
          <Text size='medium'>To boost sales like never before</Text>
        </Desc>
        <ButtonContainer>
          <Button primary size='slim'>Add products</Button>
        </ButtonContainer>
        <Image />
      </Wrapper>
    )
  }
}


CreateNewScene.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default CreateNewScene



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyIAEditorLayer/CreateNewScene.js